<script>
import store from '@state/store'
import { debounce } from 'debounce'

export default {
  methods: {
    filterData(data) {
      const newData = data.map((item) => {
        const { id, text } = item
        return { id, name: text }
      })
      return JSON.stringify(newData)
    },
    searchGroups: debounce(async function searchGroups() {
      if (!this.groupTag) {
        return
      }

      store
        .dispatch('adminGroups/searchGroupsOfCompany', {
          groupTag: this.groupTag,
        })
        .then((data) => {
          if (data instanceof Array && data.length) {
            data.slice(0, 15)
            const groupDisplayTags = data.map((item) => {
              const { id, name } = item
              return { id, text: name }
            })
            this.groupDisplayTags = groupDisplayTags
          }
        })
    }, 500),
    searchUsers: debounce(async function searchUsers() {
      if (!this.userTag) {
        return
      }
      store
        .dispatch('adminUsers/searchUsersOfGroup', {
          companyId: this.companyId,
          groupId: this.groupId,
          userTag: this.userTag,
        })
        .then((data) => {
          if (data instanceof Array && data.length) {
            data.slice(0, 15)
            const userDisplayTags = data.map((item) => {
              const { id, name } = item
              return { id, text: name }
            })
            this.userDisplayTags = userDisplayTags
          }
        })
    }, 500),
    addSearchUser() {
      if (!this.userTags && !this.groupTags && !this.uploadFile) {
        return
      }
      const params = new FormData()
      params.append(
        'allUsers',
        this.userTags.length ? this.filterData(this.userTags) : undefined
      )
      params.append(
        'allGroups',
        this.groupTags.length ? this.filterData(this.groupTags) : undefined
      )
      params.append('csv', this.uploadFile ? this.uploadFile : false)

      store
        .dispatch('adminUsers/addUsersToGroup', {
          groupId: this.groupId,
          params,
        })
        .then((response) => {
          this.$emit('refresh-members-table')
          // reset
          this.uploadFile = ''
          this.uploadFileName = ''
          this.allUsers = []
          this.allGroups = []

          this.userTag = ''
          this.userTags = []
          this.userDisplayTags = []
          this.groupTag = ''
          this.groupTags = []
          this.groupDisplayTags = []
          alert('Users have been successfully invited!')
        })
        .catch((err) => alert(err.message || 'Something went wrong.'))
    },
  },
}
</script>
